import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {

    constructor () {};

    getWindow() {
        return window;
    }

    isNarrowWindow() {
        return window.innerWidth < 900;
    }

    isMobileWindow() {
      return window.innerWidth < 415;
    }
}
